"use strict";

var _defineProperty = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var RequestType,
    OutputFormat,
    __awaiter = this && this.__awaiter || function (e, u, a, p) {
  return new (a = a || Promise)(function (o, t) {
    function s(e) {
      try {
        n(p.next(e));
      } catch (e) {
        t(e);
      }
    }

    function r(e) {
      try {
        n(p.throw(e));
      } catch (e) {
        t(e);
      }
    }

    function n(e) {
      var t;
      e.done ? o(e.value) : ((t = e.value) instanceof a ? t : new a(function (e) {
        e(t);
      })).then(s, r);
    }

    n((p = p.apply(e, u || [])).next());
  });
},
    __rest = this && this.__rest || function (e, t) {
  var o = {};

  for (r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) for (var s = 0, r = Object.getOwnPropertySymbols(e); s < r.length; s++) {
    t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[s]) && (o[r[s]] = e[r[s]]);
  }
  return o;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.fromLatLng = exports.fromPlaceId = exports.fromAddress = exports.geocode = exports.enableAddressDescriptor = exports.setOutputFormat = exports.setLocationType = exports.setResultType = exports.setBounds = exports.setComponents = exports.setRegion = exports.setLanguage = exports.setKey = exports.setDefaults = exports.OutputFormat = exports.RequestType = void 0, function (e) {
  e.ADDRESS = "address", e.LATLNG = "latlng", e.PLACE_ID = "place_id";
}(RequestType = exports.RequestType || (exports.RequestType = {})), function (e) {
  e.XML = "xml", e.JSON = "json";
}(OutputFormat = exports.OutputFormat || (exports.OutputFormat = {}));
var GOOGLE_GEOCODE_API = "https://maps.googleapis.com/maps/api/geocode";
var defaultOptions = {
  outputFormat: OutputFormat.JSON
};

function geocodeRequest(n) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var e, t, o, s, r;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e = n["outputFormat"], t = __rest(n, ["outputFormat"]), t = new URLSearchParams(t).toString(), e = GOOGLE_GEOCODE_API + "/".concat(e, "?") + t;
            _context.prev = 1;
            _context.next = 4;
            return fetch(e);

          case 4:
            _context.next = 6;
            return _context.sent.json();

          case 6:
            o = _context.sent;
            s = o.status;
            r = o.error_message;

            if (!("OK" === s)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", o);

          case 11:
            throw new Error("Geocoding failed: ".concat(r, ". Server returned status code ").concat(s, "."));

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);

            if (!(_context.t0 instanceof Error)) {
              _context.next = 18;
              break;
            }

            throw new Error("Geocoding request failed: " + _context.t0.message);

          case 18:
            throw new Error("Geocoding request failed with unknown error: " + _context.t0);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 14]]);
  }));
}

function setDefaults(e) {
  defaultOptions = Object.assign(Object.assign({}, defaultOptions), e);
}

function setKey(e) {
  defaultOptions.key = e;
}

function setLanguage(e) {
  defaultOptions.language = e;
}

function setRegion(e) {
  defaultOptions.region = e;
}

function setComponents(e) {
  defaultOptions.components = e;
}

function setBounds(e) {
  defaultOptions.bounds = e;
}

function setResultType(e) {
  defaultOptions.result_type = e;
}

function setLocationType(e) {
  defaultOptions.location_type = e;
}

function setOutputFormat(e) {
  defaultOptions.outputFormat = e;
}

function enableAddressDescriptor(e) {
  defaultOptions.enable_address_descriptor = e;
}

function geocode(e, t, o) {
  if ("string" != typeof e || "string" != typeof t) throw new Error("Both requestType and value are required and must be of type string. \n       requestType: ".concat(typeof e, ", value: ") + typeof t);
  return geocodeRequest(Object.assign(Object.assign(Object.assign({}, defaultOptions), o), _defineProperty({}, e, t)));
}

function fromAddress(e, t, o, s) {
  var r = {
    outputFormat: OutputFormat.JSON
  };
  return t && (r.key = t), o && (r.language = o), s && (r.region = s), geocode(RequestType.ADDRESS, e, r);
}

function fromPlaceId(e, t, o, s) {
  var r = {
    outputFormat: OutputFormat.JSON
  };
  return t && (r.key = t), o && (r.language = o), s && (r.region = s), geocode(RequestType.PLACE_ID, e, r);
}

function fromLatLng(e, t, o, s, r, n) {
  var u = {
    outputFormat: OutputFormat.JSON
  };
  return o && (u.key = o), s && (u.language = s), r && (u.region = r), n && (u.location_type = n), geocode(RequestType.LATLNG, e + "," + t, u);
}

exports.setDefaults = setDefaults, exports.setKey = setKey, exports.setLanguage = setLanguage, exports.setRegion = setRegion, exports.setComponents = setComponents, exports.setBounds = setBounds, exports.setResultType = setResultType, exports.setLocationType = setLocationType, exports.setOutputFormat = setOutputFormat, exports.enableAddressDescriptor = enableAddressDescriptor, exports.geocode = geocode, exports.fromAddress = fromAddress, exports.fromPlaceId = fromPlaceId, exports.fromLatLng = fromLatLng;